import Coa from '@tencent/Coa/index'
import RequestError from '@tencent/Coa/lib/RequestError'
import RequestErrorType from '@tencent/Coa/lib/RequestErrorType'

export function request (options) {
  return Coa(
    // Coa.Retry(1),
    Coa.Report(),
    Coa.Timeout(options.timeout || 7000)
  ).run(options.url, options.data)
}

export function post (options) {
  return new Promise((resolve, reject) => {
    window.$.ajax({
      url: options.url,
      type: 'post',
      data: JSON.stringify(options.params),
      dataType: 'json',
      contentType: 'text/plain',
      timeout: 5000,
      xhrFields: {
        withCredentials: true
      },
      success (json) {
        if (json) {
          let successCode = options.successCode || [0]
          let success = false
          successCode.forEach(code => {
            if (code === json.ret) {
              success = true
            }
          })
          if (success) {
            resolve(json)
          } else {
            reject(new RequestError(json.ret, json.msg || '操作失败！请重试', null, json.ret))
          }
        } else {
          reject(new RequestError(0, '服务器开小差了！请重试', null, RequestErrorType.NETWORK_ERR))
        }
      },
      error (xhr, errType) {
        if (errType === 'timeout') {
          reject(new RequestError(1, '网络返回超时！请重试', null, RequestErrorType.NETWORK_ERR))
        } else {
          reject(new RequestError(0, '网络开小差了！请重试', null, RequestErrorType.NETWORK_ERR))
        }
      }
    })
  })
}
